import axios from "axios"
import store from "../../redux/store"
import {
  setToastBoxDescription,
  setToastBoxStatus,
} from "../../redux/ToastBoxSlice"

import { triggerAuthError, getGlobalAuthError, triggerAuthRedirect } from "../../context/AuthContext"

const BASE_URL = process.env.REACT_APP_API_URL
const userApi = axios.create({
  baseURL: `${BASE_URL}/api/user`,
})
userApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("userToken")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

userApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log({ error: error.response.data?.message })
      localStorage.removeItem("userToken")
      localStorage.removeItem("username")
      
      const errorMessage =  "You were logged out . If you want to login again please come back from grinds360";
      console.log({abc:getGlobalAuthError()});
      
      if (!getGlobalAuthError()) {
        triggerAuthError(errorMessage);
      }
      
      if (window.location.pathname.startsWith("/exam-papers/") || (window.location.pathname.startsWith("/exam-papers") && window.location.pathname !== "/exam-papers")) {
        triggerAuthRedirect("/exam-papers")
      }
        
    }
    return Promise.reject(error)
  }
)

export default userApi
